<template>
  <div class="share-list share-list-book">
    <div class="list-head">
      <div class="header-wrap header-public clearfix">
        <div class="header-left cleearfix">
          <i class="icon-czur-logo"></i>
        </div>
      </div>
    </div>
    <div class="file-list view-content clearfix">
      <div class="fixed-line clearfix">
        <div class="fixed-left">
          <div class="share-message">
            <span class="share-text year">{{year}}&nbsp;</span>
            <span class="share-text detail" v-if="lang === 'en'">
              {{month}} {{day}} {{$t('share.shared') + userName}}
            </span>
            <span class="share-text detail" v-else-if="lang === 'ru_RU'">
              {{month}} {{day}} {{$t('share.shared') + userName}}
            </span>
            <span class="share-text detail" v-else>
              {{month}}月{{day}}日{{userName}}分享的文件
            </span>
            <div class="checkbox-wrapper">
              <div class="checkbox" :class="{'selected': selectedNum == folders.length}" @click="selectAll"></div>
            </div>
            <div class="download-wrapper">
              <i class="icon-download" :class="{'show': selectedNum > 0}" @click="downloadImages"></i>
            </div>
          </div>
        </div>
        <div class="total-item">{{$t('list.total')}} {{folders.length}} {{$t('list.items')}}</div>
      </div>
      <div class="view-item folder-item" :class="{'selected': folder.selected}" v-for="(folder, index) in folders" :key="index" @click="goShareListDetail(index)">
        <div class="wrapper">
          <div class="layer layer-under"></div>
          <div class="layer layer-middle"></div>
          <div class="layer layer-upper"></div>
          <div class="img-wrap">
            <img class="defaul-tag-img" :src="folder.smallUrl" alt="">
          </div>
          <div class="view-item-t tag-msg">
            <i class="icon-folder"></i>
            <span class="tag-title">{{folder.name}}</span>
          </div>
          <div class="checkbox" @click.stop="selectedFn(index)"></div>
        </div>
        <div class="tag-mark"></div>
      </div>
    </div>
    <!-- 下载打包进度 -->
    <process-bar v-if="showProcessBar" :percentage="packageProcess" :text="loadingText" style="position: fixed"></process-bar>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Notes from 'common/model/Notes'
import ProcessBar from './ProcessBar'
export default {
  name: 'shareList',
  components: {ProcessBar},
  data () {
    return {
      year: '',
      month: '',
      day: '',
      userName: '',
      folders: [],
      selectedNum: 0,
      code: '',
      type: '',
      loadingText: this.$t('share.package'),
      packageProcess: 0,
      showProcessBar: false,
      lang: ''
    }
  },
  created () {
    if (this.$i18n.locale === 'en') {
      this.lang = 'en'
    }
    if (this.$i18n.locale === 'ru_RU') {
      this.lang = 'ru_RU'
    }
    this.getShareList()
  },
  methods: {
    downloadImages: function () {
      this.packageProcess = 0
      this.showProcessBar = true
      var selectedId = []
      for (var i = 0; i < this.folders.length; i++) {
        if (this.folders[i].selected) {
          if (this.type === '0' || this.type === '1') {
            selectedId.push(this.folders[i].id)
          } else if (this.type === '2') {
            selectedId.push(this.folders[i].name)
          }
        }
      }
      selectedId = selectedId.join(',')
      HttpClient.postData(Config.APP_HOST + '/v1/book/batchDownload', {
        u_id: this.folders[0].userId,
        fileStrs: selectedId,
        type: this.type
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          var key = response.body.redisKey
          this.packageUrl = response.body.downloadUrl
          var thisObj = this
          this.packageTimer = setInterval(function () {
            thisObj.getPackageProcess(key)
          }, 1000)
        }
      })
    },
    getPackageProcess: function (key) {
      HttpClient.postData(Config.APP_HOST + '/v1/book/batchDownloadProgress', {
        u_id: this.folders[0].userId,
        redisKey: key
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response)
          var status = response.body.split(':')
          if (status[0] === 'download') {
            this.packageProcess = Math.round(status[1] / 4)
          } else if (status[0] === 'compress') {
            this.packageProcess = 25 + Math.round(status[1] / 2)
          } else if (status[0] === 'upload') {
            this.packageProcess = 75 + Math.floor(status[1] / 4)
          }
          if (this.packageProcess >= 100) {
            clearInterval(this.packageTimer)
            var tempThis = this
            setTimeout(function () {
              tempThis.showProcessBar = false
              window.location.href = tempThis.packageUrl
            }, 100)
          }
        }
      })
    },
    getShareList: function () {
      this.code = Config.getLocalStore('shareCode')
      HttpClient.postData(Config.APP_HOST + '/v1/book/public/validateShareFileLink', {
        groupId: this.$route.params.shareId,
        code: this.code
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          var date = response.body.shareDate
          date = date.split('-')
          this.year = date[0]
          this.month = date[1]
          this.day = date[2].split(' ')[0]
          this.userName = response.body.userName
          this.type = response.body.type
          for (var i = 0; i < response.body.packageList.length; i++) {
            var notes = new Notes()
            notes.loadShareFolderData(response.body.packageList[i])
            this.folders.push(notes)
          }
        }
      })
    },
    // 之前的
    goShareListDetail: function (index) {
      if (this.selectedNum > 0) {
        this.selectedFn(index)
        return
      }
      this.$router.push({path: '/share/book/' + this.$route.params.shareId + '/list/detail', query: {u_id: this.folders[index].userId, id: this.folders[index].id, name: this.folders[index].name, type: this.type}})
    },
    selectAll: function () {
      if (this.selectedNum === this.folders.length) {
        for (var i = 0; i < this.folders.length; i++) {
          this.folders[i].selected = false
        }
        this.selectedNum = 0
      } else {
        for (var k = 0; k < this.folders.length; k++) {
          this.folders[k].selected = true
        }
        this.selectedNum = this.folders.length
      }
    },
    selectedFn: function (index) {
      this.folders[index].selected = !this.folders[index].selected
      if (this.folders[index].selected) {
        this.selectedNum += 1
      } else {
        this.selectedNum -= 1
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
body,html
  height 100%
  min-height 100%
.share-list, .share-list-book
  position relative
  width 100%
  min-height 100%
  height 100%
  background-color #fafafa
  box-sizing border-box
  overflow-y auto
  .list-head
    width 100%
    height 50px
    line-height 50px
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    color #3d3d3d
    z-index 99
    .header-wrap
      &.header-public
        width 100%
        height 100%
        background-color #fff
        border-bottom 1px solid #ebebeb
        font-size 14px
        display block
        .header-left
          float left
          .icon-czur-logo
            float left
            margin 14px 79px 14px 20px
            font-size 22px
            color #3d3d3d
  .file-list
    display block
    width 100%
    &:hover
      .fixed-line
        .fixed-left
          .checkbox
            display inline-block
    .fixed-line
      display block
      .fixed-left
        width 80%
        .share-message
          width 60%
          position relative
          cursor pointer
          text-align left
          color #000000
          overflow hidden
          .share-text
            display block
            float left
          .year
            font-size 16px
          .detail
            line-height 45px
        .checkbox-wrapper
          position relative
          display inline-block
          float left
          width 40px
          height 40px
        .checkbox
          top 10px
          left 10px
          &.selected
            display inline-block
            background-image url('../../assets/images/checkbox_click.png')
        .download-wrapper
          display block
          float left
          width 40px
          height 40px
          text-align center
          padding-top 5px
          box-sizing border-box
          .icon-download
            display none
            font-size 20px
            color #3d3d3d
            &.show
              display inline-block
      .total-item
        color #000000
    .folder-item
      display block
      justify-content center
      align-items center
      position relative
      transition all .3s ease
      cursor pointer
      &.selected
        .checkbox
          display block
          background-image url('../../assets/images/checkbox_click.png')
      &:hover
        .wrapper
          top -8px
          .img-file
            box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
          .layer
            &.layer-under
              width 154px
              height 170px
              top -2px
              margin-left -77px
              box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
            &.layer-middle
              width 166px
              height 170px
              top 5px
              margin-left -83px
              box-shadow rgba(218, 218, 218, 0.64) 0px 17px 50px 0px
            &.layer-upper
              width 178px
              height 170px
              top 12px
              margin-left -89px
              box-shadow rgba(218, 218, 218, 0.64) 0px 17px 45px -10px
        .checkbox
          display block
      .wrapper
        display flex
        width 100%
        height 100%
        flex-direction row
        justify-content center
        align-items center
        position relative
        transition all .3s ease
        cursor pointer
      .img-file
        width 100%
        height 100%
        max-width 100%
        max-height 100%
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        margin auto
        transition all .3s ease
        img
          max-width 100%
          max-height 100%
          transition all .3s ease
      .layer
        position absolute
        left 50%
        border 1px solid #e5e5e5
        border-radius 4px
        background-color #fff
        transition all .25s ease
        &.layer-under
          width 160px
          height 170px
          top 0
          margin-left -80px
          transition all .25s ease-in
        &.layer-middle
          width 170px
          height 170px
          top 6px
          margin-left -85px
          transition all .25s ease-in
        &.layer-upper
          width 178px
          height 170px
          top 12px
          margin-left -89px
      .img-wrap
        width 120px
        height 120px
        position absolute
        top 25px
        left 50%
        margin-left -60px
        background-color #fafafa
        border-radius 4px
        display flex
        justify-content center
        align-items center
        img
          max-width 100%
          max-height 100%
          display block
          &.folder-img
            display block
      .tag-msg
        .icon-folder
          vertical-align middle
        .tag-title
          color #3d3d3d
          font-weight 500
          display inline-block
          max-width 119px
          height 12px
          line-height 12px
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
          vertical-align middle
          text-align left
      .checkbox
        bottom 10px
        right 12px
      .tag-mark
        width 100%
        height 102%
        position absolute
        top -9px
        left 0
        background-color #dedcdc7a
        border-radius 21px 21px 0 0
        display none
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ShareList.vue